let $ = jQuery;
let doneresizevar, wScreen;
var nbNewsByPage = 9;
var filtersPortfolio = [];
var  newLinkUrl = '';
var filterTypo = [];

import css from '../sass/styles.scss'

$(window).resize(function(){
	clearTimeout(doneresizevar);
	doneresizevar = setTimeout(resize, 500);
	$('.hamburger').removeClass('is-active');
	$('#menumobile').removeClass('open');
	$('body').removeClass('oh');
});
$(window).scroll(function(){	
	// console.log($(window).scrollTop() +'>'+ $('header.header').outerHeight());
	if($(window).scrollTop() > $('header.header').outerHeight()){
		$('body').addClass('scrolled');
	}else if($(window).scrollTop() == 0){
		$('body').removeClass('scrolled');
	}
	lazyCheck();
	
	if($('div.followus').length > 1){
		var topParent= ($('div.followus').parent().offset().top);
		var hParent = ($('div.followus').parent().outerHeight());
		var topPage = $('html').scrollTop();
		var hHeader = $('header.header--top').outerHeight();
		var hWindow = $(window).outerHeight();
		if(topPage + hHeader > (topParent - 50) ){
			// $('div.followus').css({'top' :  (topPage - $('.header--page').outerHeight() + 200)+'px'});
			if(hParent - 200 > (topPage - (hWindow /  2)))
				$('div.followus').css({'top' :  (topPage - (hWindow /  2))+'px'});
		}else{
				$('div.followus').css({'top' :  '150px'});
		}
	}
});

$(document).ready(function(){
	clearTimeout(doneresizevar);
	doneresizevar = setTimeout(resize, 500);
	
			// File input 
			$( '.inputfile' ).each( function(){
				var $input   = $( this ),
				$label   = $input.next( 'label' ),
				labelVal = $label.html();
		
				$input.on( 'change', function( e )
				{
				var fileName = '';
		
				if( this.files && this.files.length > 1 )
					fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
				else if( e.target.value )
					fileName = e.target.value.split( '\\' ).pop();
		
				if( fileName )
					$label.find( 'span' ).html( fileName );
				else
					$label.html( labelVal );
				});
			});
	  
			$(document).on('keypress','input[type="text"], textarea',function(){
				var input = $(this).attr('placeholder');
				$(this).next().text(input);
			})
			$(document).on('keyup','input[type="text"], textarea',function(ev){
				var keyCode = ev.keyCode || ev.which;
				if(keyCode != 9){
					var input = $(this).attr('placeholder');
					$(this).next().text($(this).val() != '' ? input : '');
				}
				if($(this).val() == ''){
					$(this).next().text('');
				}
			})
			$(document).on('focus','input[type="text"], textarea',function(){
				$(this).removeClass('error');
			})
			$(document).on('click','.error',function(){
				$(this).removeClass('error');
				$('p#answerform').html('');
			})
			$(document).on('blur','input[type="text"], textarea',function(){
				if($(this).val() == ''){
					$(this).next().text('');
				}
				// checkFields('applyform');
			})
			$('input[type="text"], textarea').each(function(){
				if($(this).val() != ''){
					var input = $(this).attr('placeholder');
					$(this).next().text(input);
				}
			})
			$(document).on('click','p.p--check',function(){
				$(this).toggleClass('checked');
				$(this).parent().removeClass('error');
			})

			if($('footer span.e').length > 0){
				let mcontact = 'contact@'
				mcontact += 'clumic.com'
				$('footer span.e').html(mcontact)
			}
	
			if($('.splide').length > 0){
				var elms = document.getElementsByClassName( 'splide' );
				var splide = '';
				var breakP = '';
				for ( var i = 0; i < elms.length; i++ ) {
					breakP = {};
					if($(elms[ i ]).data().slug && $(elms[ i ]).data().slug == 'customers'){
						breakP =
						{
							1200: {
								perPage: 5,
							},
							1000: {
								perPage: 4,
							},
							768: {
								perPage: 3,
							},
							500: {
								perPage: 2,
							}
						};
					}

					splide = new Splide( elms[ i ], {
						type   : 'loop',
						autoplay: true,
						perPage: $(elms[ i ]).data().perpage ? $(elms[ i ]).data().perpage : 1,
						pagination: $(elms[ i ]).data().pagination,
						speed: $(elms[ i ]).data().speed ? $(elms[ i ]).data().speed : 1000,
						breakpoints : breakP,
						
	
					} ).mount();

					if(!$(elms[ i ]).data().pagination){
						console.log('fr')
						splide.options = {
							breakpoints: {
								1000: {
									perPage: 3,
								},
						  }
						};
					}
				}
			}
	
	$(document).on('click','.data-href',function(){
		var linkUrl = $(this).data().href;
		document.location.href = linkUrl;
	})
	
	$(document).on('click','.sendinblue .sib-title',function(){
		if($('.sib-info').is(':visible'))
			$('.sib-info').slideUp();
		else
			$('.sib-info').slideDown();
	})
	$(document).on('click','.sendinblue .sib-info .close',function(){
		$('.sib-info').slideUp();
	})
	
	$(document).on('click','.toppage--a',function(){
		$('html,body').animate({ scrollTop: 0 }, 1000);
	})
	
	$(document).on('click','.dropdown',function(e){
		$(this).toggleClass('opened')
		e.preventDefault();
		if($(this).next().is(':visible'))
			$(this).next().slideUp();
		else
			$(this).next().slideDown();
	})
	
	if($('.txtcontent').length > 0){
		$('.txtcontent').each(function(){
			var fontfamily = $(this).data().font;
			$(this).find('p,li').css({'font-family' : fontfamily});
		})
	}
	
	
	addClassesLiMenu();	
	
	if($('div.sliders').length > 0){
		$('div.sliders').slick({
			slide: '.slides',
			autoplay: true,
			arrows: false,
			dots: false,
			infinite: true,
			autoplaySpeed: 5000,
			horizontal: true
		});
	}
	
	// var  header = $('header.header .header--inside').html();
	// $('footer header').html(header);
	// $('footer header').addClass('header page--container');
	// $('footer header img.logo-img').attr('src',$('footer header img.logo-img').attr('src').replace('-clumic','-white'));
	// $('footer .hamburger').remove()
	if($('.followus').length > 0){
		$('header.header--top ul.sub-menu a').each(function(){
			var rsHref = $(this).attr('href');
			var rsAnchor = $(this).text();
			$('div.followus ul').append('<li><a href="'+rsHref+'" tagret="_blank">'+rsAnchor+'</a></li>');
		})
	}
	
	$(document).on('click','.hamburger', function(){
		$(this).toggleClass('is-active')
		$('#menumobile').toggleClass('open');
		if($(this).hasClass('is-active'))
			$('body').addClass('oh');
		else
			$('body').removeClass('oh');
	});
	$(document).on('touch','.menu-item-has-children', function(){
	});
	$(document).on('click','.menu-item-has-children', function(){
	});
	$(document).on('mouseover','.menu-item-has-children', function(){
	});
	$(document).on('mouseout','.menu-item-has-children', function(){
	});
	
	$(document).on('touch','.filters a:not(.dropdown):not(.cpdt)', function(){
		filterPortfolio(this);
	});
	$(document).on('click','.filters a:not(.dropdown):not(.cpdt)', function(){
		filterPortfolio(this);
	});
	$(document).on('click','.brick', function(){
		if($(this).data().slug){
			document.location.href = $(this).data().slug;
		}
	});

	$(document).on('click','.brick.visuels img', function(){
		var urlimg = $(this).attr('src');
		var urlimg1 = $('.brick.visuels div:nth-child(1) img').attr('src');

		$('.brick.visuels div:nth-child(1) img').addClass('scale0')

		setTimeout(function(){
			$('.brick.visuels div:nth-child(1) img').attr('src', urlimg);
			$('.brick.visuels div:nth-child(1) img').attr('data-src', urlimg);
			$('.brick.visuels div:nth-child(1) img').removeClass('scale0')
		},400)

		$(this).attr('src',urlimg1);
		$(this).attr('data-src',urlimg1);
	});

	$(document).on('click','#more-ref', function(){
		$('div[class*="pattern_"]:hidden').eq(0).addClass('showned');
		if($('div[class*="pattern_"]:hidden').length < 1){
			$('a#more-ref').fadeOut()
		}
	})
	
	$(document).on('click','#more-testi', function(){
		$('.testimonials div[class*="line"]:hidden').eq(0).addClass('showned');
		if($('.testimonials div[class*="line"]:hidden').length < 1){
			$('a#more-testi').fadeOut()
		}
	})
	
	if(typeof(news) != 'undefined' && news.length > 0){
		$('.pagination').html('<a href="javascript:void(0)" data-page="1" class="__btn_orange">Voir plus</a>');
	}
	$(document).on('click','.pagination a',function(){
		var page = $(this).data().page;
		if(nbNewsByPage >= news.length){
			$('.pagination').remove();
		}
		for(var i = 0; i < nbNewsByPage; i++){
			if(news[i]){
				var article = '<article class="data-href d_n" style="opacity: 0" data-href="'+news[i].href+'">';
				article += '<div class="thumb" style="background: url('+news[i].thumb+') no-repeat center center / cover"></div>';
				article += '<h2><a href="'+news[i].href+'" title="'+news[i].title+'">'+news[i].title+'</a><span class="postdate">'+news[i].postdate+'</span><em></em></h2>';
				article += '<p>'+news[i].excerpt+'</p></article>';
				$('.listnews').append(article);
			}
		}
		$('article.d_n').each(function(){
			$(this).show().animate({opacity : 1}, 500);
		})
		for(var i = 0; i < nbNewsByPage; i++){
			if(news[i]){
				news.splice(i,1);
			}
		}
		$(document).on('click','.error', function(){
			$(this).removeClass('error');
		});
		$(document).on('focus','.error *', function(){
			$(this).parent().removeClass('error');
		});
		
	})
	
	if(($('#map').length > 0 && document.location.href.indexOf('clumic.com') == -1)){//-services
		initMap();
	}
	$(document).on('click','.p--check',function(){
		$(this).toggleClass('ok');
		$(this).parent().removeClass('error');
	})
	$(document).on('click','a#sendform', function(){
		sendForm();
	})
	$('body').append('<div id="menumobile" class="menu--mobile"></div>');
	$('#menumobile').html($('#menunav').html());
	
	$(document).on('click', '.a--rs',function(e){
		e.preventDefault();
		var rsWindow = window.open(this.href, 'rs-popup', 'height=350,width=600');
		if(rsWindow.focus) { rsWindow.focus(); }
			return false;
	})
	
	$(document).on('click', '#emailform',function(e){
		e.preventDefault();
		sendForm();
	})
	

	$(document).on('click', '.filter--custom li',function(){
		let filtersblock = $(this).closest('.filters')
		let oTop = $(filtersblock).offset().top
		$('html,body').animate({ scrollTop: oTop - $('.header--inside').outerHeight() }, 500)
	
		filterCustomers(this);
	})

	// if($('body').hasClass('clients')){
	// 	$('ul[data-logos="customer"]').find('li:nth-child(1)').click();
	// }
	$(document).on('click', '.store--bg, .b--popin a.popin--close', function(){
		$('body').removeClass('oh')
		$('.store--bg, .store--inside').fadeOut()
		sessionStorage.setItem("displayPopin","1")
	})
	$(document).on('click', '.store--bg--newsletter, .b--newsletter a.popin--close', function(){
		$('body').removeClass('oh')
		$('.store--bg--newsletter, .store--inside').fadeOut()
		sessionStorage.setItem("displayPopinNewsletter","1")
	})
	if($('.store--bg').length > 0){
		let displayPopin = sessionStorage.getItem("displayPopin");
		if(displayPopin === null){
			$('.store--bg, .store--inside').fadeIn();
			$('body').addClass('oh')
		}
	}
	if($('.store--bg--newsletter').length > 0){
		let displayPopinNewsletter = sessionStorage.getItem("displayPopinNewsletter");
		if(displayPopinNewsletter === null){
			$('.store--bg--newsletter, .store--inside').fadeIn();
			$('body').addClass('oh')
		}
	}
	
});


function filterCustomers(elt){
	filterTypo = [];
	$(elt).closest('ul').find('li').removeClass('active');
	$(elt).addClass('active');
	let logos = $(elt).parent().data().logos;
	let filterConcerned = $(elt).parent();
	if($(elt).data().filter * 1 == 0){
		$(elt).addClass('active');
		$(filterConcerned).find('li:not(.first)').each(function(){
			$(this).removeClass('active');
		})
		$('.'+logos+' .brick').each(function(){
			$(this).css({'display' : 'block'});
			$(this).removeClass('off');
		})
	}else{
		// $(filterConcerned).find('li:nth-child(1)').removeClass('active');
		let activFilters = $(filterConcerned).find('li.active');
		if(activFilters.length > 0){
			$(activFilters).each(function(){
				filterTypo.push($(this).data().filter);
			})	
			
			$('.'+logos+' .brick').each(function(){
				var hideBlock = true;
				var items = $(this).data().item.split(' ');
				$(items).each(function(){
					if(isItemInFilters(this,filterTypo) != -1)
						 hideBlock = false;
				})
				if(hideBlock){
					$(this).addClass('off');
					var $this  = this;
					setTimeout(function(){
						$($this).css({'display' : 'none'});
					},700);
				}
				else{
					$(this).css({'display' : 'block'});
					$(this).removeClass('off');
				}
			})
			
		}else{
			$('.'+logos+' .brick').each(function(){
				$(this).css({'display' : 'block'});
				$(this).removeClass('off');
			})
		}
	}
}

function isItemInFilters(id,list){
	for (var i=0;i<list.length;i++){
		if (list[i] && id == list[i]){
			return i;
		}
	}
	return -1;
}


function getOffset(element) { // Notre fonction qui calcule le positionnement complet
		var top = 0,
				left = 0;

		do {
				top += element.offsetTop;
				left += element.offsetLeft;
		} while (element = element.offsetParent); // Tant que « element » reçoit un « offsetParent » valide alors on additionne les valeurs des offsets

		return { // On retourne un objet, cela nous permet de retourner les deux valeurs calculées
				top: top,
				left: left
		};
}

function filterPortfolio(elt){
	$('#more-ref').hide()
	$('div.line').removeClass('showned vis_')
	let filtersblock = $(elt).closest('.filters')
	let oTop = $(filtersblock).offset().top
	$('html,body').animate({ scrollTop: oTop - $('.header--inside').outerHeight() }, 500)

	filtersPortfolio = [];
	$(elt).closest('.filters').find('a').removeClass('activ');
	$(elt).addClass('activ');
	var filter = $(elt).data().filter;
	if($('.filters a.activ').length == 0){
		filter = '0';
	}
	if(filter == '0'){
		$('.filters a').removeClass('activ');
		$('.filters li:nth-child(1) a').addClass('activ');
		filtersPortfolio = ['0'];
	}else{
		var inFilter = filtersPortfolio.indexOf('0');
		$('.filters li:nth-child(1) a').removeClass('activ');
		if(inFilter != - 1){
			filtersPortfolio.splice(0,1);
		}
	}
	reloadPortfolio(filter);
}

function reloadPortfolio(filter){
	$('section.ref .ref--brick').html('');
	$('section.ref .ref--brick').each(function(){
		$(this).css({"background" : "none", 'opacity' : 0});
	})
	if(filter != '0'){
		var inFilter = filtersPortfolio.indexOf(filter);
		if(inFilter === - 1){
			filtersPortfolio.push(filter);
		}else{
			filtersPortfolio.splice(inFilter,1);
		}
	}
	var indexBrick = 0;
	// console.log(references.length);
	for(var i = 0; i < references.length; i++){
		var loop = true;
		for(var j = 0; j < references[i].categories.length; j++){
			if(filtersPortfolio.indexOf(references[i].categories[j]) != -1 && loop === true || (filter == 0 && loop === true)){
				loop = false;
				$('.ref .brick_'+indexBrick).removeClass('data-bg');
				$('.ref .brick_'+indexBrick).attr('data-bg',references[i].visuel);
				$('.ref .brick_'+indexBrick).css({"background" : 'url('+references[i].visuel+') no-repeat center center / cover'});
				// $('.ref .brick_'+indexBrick).removeClass('data-href');
				// newLinkUrl = references[i].permalink;
				// $(document).on('click',$('.ref .brick_'+indexBrick),function(){
					// document.location.href = newLinkUrl;
				// })
				// alert(references[i].credit);
				$('.ref .brick_'+indexBrick).append('<a href="'+references[i].permalink+'"></a><div class="div--abs"><h3>'+references[i].title+'<span>'+references[i].subtitle+'</span></h3>'+references[i].credit+'</div>');
				$('.ref .brick_'+indexBrick).animate({'opacity' : 1}, 1000);
				$('.ref .brick_'+indexBrick).closest('.line').addClass('showned')
				// var classRef = [];
				// $(references[i].categories).each(function(){
					// classRef.push('cat_'+this);
				// })
				// if(classRef.length > 0){
					// $('.ref .brick_'+indexBrick).addClass(classRef.join(' '));
				// }
				indexBrick++;
			}
		}
	}
}



function insertAfter(newNode, referenceNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function addClassesLiMenu(){
	$('#menunav li a').each(function(){
		var link = $(this).attr('href').split('/');
		$(this).parent().addClass(link[(link.length - 1)]);
	})
}

function checkFields(formid){
	var ok = 1;
	$('#'+formid+' input[type="text"], #'+formid+' textarea').each(function(){
		if($(this).val() == ''){
			ok = 0;
		}
	})
	if(ok == 1){
		if(formid == 'applyform'){
			if($('#job').val() != '' && $('#job').val() != null && $('#uploaded').val() == 1){
				ok = 1;
			}else{
				ok = 0;
			}
		}
	}else{
		ok = 0;
	}
	if(ok == 1)
		$('#sendform').addClass('ok');
	else
		$('#sendform').removeClass('ok');
	
}

function lazyCheck(){
	// var bgimg = $(this).css('background-image').replace('url(','').replace(')','').replace(/\"/gi, "");
	var widthBody = $('body').innerWidth();
							// console.log(widthBody);
	$('.data-bg').each(function() { 
		var objectTop = $(this).offset().top;
		var windowBottom = $(window).scrollTop() + window.innerHeight;
		if (objectTop <= windowBottom) {
				
				if ($(this).length>0)
				{
					var bgurl = $(this).data().bg;
					$(this).css({"background" : 'url('+bgurl+') no-repeat center center / cover'});
				}
		}
	})
	$('.lazycheck').each(function() { 
		var objectTop = $(this).offset().top;
		var windowBottom = $(window).scrollTop() + window.innerHeight;
		if (objectTop <= windowBottom) {
				
				if ($(this).length>0)
				{
					var srcurl = $(this).data().src;
					$(this).attr('src',srcurl);
					$(this).removeClass('lazycheck');
				}
		}
	})
	$('.has_anim').each(function() { 
		var objectTop = $(this).offset().top;
		var windowBottom = $(window).scrollTop() + window.innerHeight;
		if (objectTop <= windowBottom) {
				
				if ($(this).length>0 && !$(this).hasClass('anim'))
				{
					$(this).addClass('anim');
				}
		}
	})
}

function resize(){
	$('.__team_worker_presentation').remove();
	wScreen = $('body').innerWidth();
	// console.log(wScreen);
	lazyCheck();
	adaptElements();
}
function adaptElements(){
	if($('body').hasClass('maintenance')){
		var hPage = $('#wrapper').outerHeight();
		var hWindow = $(window).innerHeight();
		hPage > hWindow ? $('#wrapper').addClass('pr') : $('#wrapper').removeClass('pr');
	}
	var pantone = $('section.pantones');
	if($(pantone).length > 0){
		if($('.pantone:nth-of-type(1)').is(':visible')){
			var lgthPantone = 0;
			var widthSectionPantone = $(pantone).outerWidth();
			$('.pantone').each(function(){
				lgthPantone += $(this).outerWidth();
			})
		}
		if(lgthPantone > widthSectionPantone)
			$(pantone).hide();
		else
			$(pantone).show();
	}
}

function sendForm(){
	var error = 0;
	$('#ifile p.error').remove();
	$('p#answerform').removeClass('block--show');
	$('form#contactform input[type="text"], form#contactform input[type="email"], form#contactform textarea').each(function(){
		if($(this).val() == '' && !$(this).hasClass('optional')){
			$(this).parent().addClass('error');
			error = 1;
		}
	})
	if(!$('.p--check').hasClass('ok')){
		$('.p--check').parent().addClass('error');
		error = 1;
	}
	if(error == 1){
		$('p#answerform').html('<span class="error">Merci de vérifier l\'ensemble des champs.</span>');
		return false;
	}
	var options = { 
		dataType:   'json',// xml
		success:   function(data){// xml
				// $(data).each(function(){
					// console.log(this);
				// });
			if (data && data.code && data.code == 'OK'){
				// document.location.href = data.return_url;

				$('form')[0].reset();
				$('#formtoken').val(data.newtoken);
				$('.p--check').removeClass('ok');
				$('p#answerform').addClass('block--show').html(data.message);
				// setTimeout(function(){
				// 	document.location.href = data.return_url;
				// },1000)
				$('.formcontact').remove();
				$('#sendform').remove();
				var  topSection = $('section.contacts').offset().top - 90;
				$('html,body').animate({ scrollTop: topSection }, 1000);
				$('.toppage').addClass('toppage-2');
			}else{
				$('p#answerform').html('<span class="error">Merci de vérifier l\'ensemble des champs.</span>');
				$(data.errors).each(function(index){
					if(data.errors[index] == '#ifile'){
						$('#ifile').append('<p class="error" style="color: #e34545;">'+data.message+'</p>');
					}
					$(data.errors[index]).addClass('error');
				});
			}
		},  // post-submit callback 				 
		url:urltheme+'/library/ajaxrequest.php',
		//clearForm: true
	}; 
	$('#contactform').ajaxSubmit(options);		
}

function shuffle(array) {
	let counter = array.length;
	// While there are elements in the array
	while (counter > 0) {
			// Pick a random index
			let index = Math.floor(Math.random() * counter);

			// Decrease counter by 1
			counter--;

			// And swap the last element with it
			let temp = array[counter];
			array[counter] = array[index];
			array[index] = temp;
	}
	return array;
}
